var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from 'lodash';
import validator from 'validator';
import { apiCreateProfileRelatedSolution } from '../../../actions/ProfileActions';
import { wrapDispatch } from '../../../helpers/action';
import { isNullOrUndefinedOrEmpty } from '../../../helpers/common';
import { strMax } from '../../utils';
import { getWithProperty } from './common';
export default {
    asyncUrl: (values, dispatch, formProp, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
        // 関連するプロジェクト事例用の非同期バリデーション＋有効時のデータ設定
        const relatedSolutionUrl = _.get(values, fieldName);
        try {
            const updateId = getWithProperty(fieldName, 'id');
            const updateTitle = getWithProperty(fieldName, 'title');
            const updateThumbnail = getWithProperty(fieldName, 'thumbnail');
            // 空の場合は何もなかったことにする
            if (isNullOrUndefinedOrEmpty(relatedSolutionUrl)) {
                dispatch(formProp.change(updateId, ''));
                dispatch(formProp.change(updateTitle, ''));
                dispatch(formProp.change(updateThumbnail, ''));
                return;
            }
            const result = yield wrapDispatch(dispatch, apiCreateProfileRelatedSolution({ relatedSolution: relatedSolutionUrl }, {}));
            dispatch(formProp.change(updateId, result.payload.id));
            dispatch(formProp.change(updateTitle, result.payload.title));
            dispatch(formProp.change(updateThumbnail, result.payload.thumbnail));
        }
        catch (e) {
            const errorObject = {};
            _.set(errorObject, fieldName, '不正なURLです');
            throw errorObject;
        }
    }),
    url: [
        strMax(255, 'URLは255文字以内で入力してください'),
        (value) => {
            if (isNullOrUndefinedOrEmpty(value)) {
                return '';
            }
            return validator.isURL(value) ? '' : 'URLを入力してください';
        },
    ],
};
